import {
	getApiRoutesMapFactory,
	ApiRoutesMap,
} from '../../../xlink/configs/ApiRoutesMap';
import { OffersModule } from '../../../xlink/modules/Offers/OffersModule';
import { OxylinkConstants } from '../OxylinkConstants';

export class IdelinkRoutesConfig {
	public static getOxylinkRouteMap = (): ApiRoutesMap => ({
		[OffersModule.PACKAGED_ORDERS_API_ROUTE_KEY]: OxylinkConstants.OFFERS_API_ROOT,
		[OffersModule.OFFER_LIST_API_ROUTE_KEY]: OxylinkConstants.OFFERS_API_ROOT,
	});

	public static initRouteMappingConfig = () => {
		getApiRoutesMapFactory.register('**', IdelinkRoutesConfig.getOxylinkRouteMap);
	};
}
